export default __webpack_public_path__ + "static/media/pt-30.cac83a24.svg";